module.exports = __webpack_public_path__ + "media/public/images/logo-small-white-a56799c24d5247fb282a41f727bf3a8b.png";